const ArrowBack = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none"><path fill="#546EDB" d="M21 0a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h17Z"/><path fill="#fff" fillRule="evenodd" d="M14.742 8.251a.9.9 0 0 0-1.248 0l-3.236 3.143a.84.84 0 0 0 0 1.212l3.236 3.143a.9.9 0 0 0 1.248 0 .84.84 0 0 0 0-1.212L12.13 12l2.612-2.537a.84.84 0 0 0 0-1.212Z" clipRule="evenodd"/></svg>
    )
}

export default ArrowBack;